import { render } from "./Config.vue?vue&type=template&id=ad01337a"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
script.render = render

export default script